import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';
import Toaster from './components/ui/Toaster';
import { decryptArray } from './utils/helpers';

const getOrgId = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if(urlParams.get('orgId')){
    const orgId = await decryptArray(urlParams.get('orgId'));
    return orgId;
  }
  else return null;
};

const Auth0ProviderWithRedirectCallback = ({ children, organization, ...props }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  return (
    <Auth0Provider
      onRedirectCallback={onRedirectCallback}
      {...props}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/typetester`,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: process.env.REACT_APP_AUTH0_SCOPE,
        organization // custom param — accessible through `appState` if needed
      }}>
      {children}
    </Auth0Provider>
  );
};

const init = async () => {
  // const orgId = await getOrgId();
  ReactDOM.render(
    <React.StrictMode>
      <ToastContainer
        autoClose={2000}
        position='bottom-center'
        theme='colored'
        hideProgressBar={true}
      />
      <Provider store={store}>
        <BrowserRouter>
          {/* {orgId === null ? */}
            <Auth0ProviderWithRedirectCallback domain={process.env.REACT_APP_AUTH0_DOMAIN} clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}>
              <App />
              <Toaster />
            </Auth0ProviderWithRedirectCallback> :
            {/* <Auth0ProviderWithRedirectCallback organization={orgId} domain={process.env.REACT_APP_AUTH0_DOMAIN} clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}>
              <App />
              <Toaster />
            </Auth0ProviderWithRedirectCallback>} */}
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

init();

reportWebVitals();
